/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import { dFix } from '@/data/Settings';
import { GTMCheckoutPayload } from '@/data/types/GTM';
import { findProductAttribute } from 'integration/utils/findProductAttribute';

export const getGTMCheckoutEventData = async (payload: GTMCheckoutPayload) => {
	const { cart, storeName, orgName, orgId, contextData } = payload;
	const { orderItem: items = [], grandTotal, grandTotalCurrency } = cart;
	const hcl_account = orgId ? orgName : null;
	const affiliation = 'Dportenis'; // This should be the Seller Organization name
	const marketplaceStore = storeName;
	const products = items.map(
		({ orderItemId, partNumber, unitPrice, quantity, currency, shipModeCode }) => {
			const product = contextData?.[orderItemId]?.product;

			const attributes = product?.attributes ?? [];
			const brand = findProductAttribute(attributes, 'Marca')?.value;
			const size = findProductAttribute(attributes, 'Talla')?.value;
			const genre = findProductAttribute(attributes, 'Genero')?.value;
			const family = findProductAttribute(attributes, 'Familia')?.value;
			const use = findProductAttribute(attributes, 'Uso')?.value;

			return {
				id: partNumber,
				name: product?.name,
				price: Number(unitPrice),
				quantity: dFix(quantity, 0),
				currency,
				shippingTier: shipModeCode,
				affiliation,
				productPrice: product.productPrice,
				keyword: product?.keyword,
				brand,
				size,
				genre,
				family,
				use,
			};
		}
	);
	return { products, grandTotal, grandTotalCurrency, marketplaceStore, hcl_account };
};
